import { ASNAPI } from './ASN'
import { Attachments } from './Attachments'
import { BarcodedUnits } from './BarcodedUnits'
import { Carriers } from './Carriers'
import { Cases } from './Cases'
import { BatchesAPI } from './Batches'
import { Clients } from './Clients'
import { Containers } from './Containers'
import { DamagedAPI } from './Damaged'
import { Facilities } from './Facilities'
import { Freight } from './Freight'
import { Lookup } from './Lookup'
import { Pallets } from './Pallets'
import { Parcel } from './Parcel'
import { Picking } from './Picking'
import { Products } from './Products'
import { Profiles } from './Profiles'
import { Skus } from './Skus'
import { Truckloads } from './Truckloads'
import { Units } from './Units'
import { API, CustomAxiosConfig } from './types'

export class Client {
  api: API

  constructor(api: API) {
    this.api = api
  }

  summary = async (config: CustomAxiosConfig = {}): Promise<any> => {
    const response = await this.api.get('/accounts/client-summary', config)
    return response.data
  }

  get asn() {
    const api = new ASNAPI(this.api)
    Object.defineProperty(this, 'asn', { value: api })
    return api
  }

  get attachments() {
    const api = new Attachments(this.api)
    Object.defineProperty(this, 'attachments', { value: api })
    return api
  }

  get batches() {
    const api = new BatchesAPI(this.api)
    Object.defineProperty(this, 'batches', { value: api })
    return api
  }

  get carriers() {
    const api = new Carriers(this.api)
    Object.defineProperty(this, 'carriers', { value: api })
    return api
  }

  get cases() {
    const api = new Cases(this.api)
    Object.defineProperty(this, 'cases', { value: api })
    return api
  }

  get clients() {
    const api = new Clients(this.api)
    Object.defineProperty(this, 'clients', { value: api })
    return api
  }

  get containers() {
    const api = new Containers(this.api)
    Object.defineProperty(this, 'containers', { value: api })
    return api
  }

  get damaged() {
    const api = new DamagedAPI(this.api)
    Object.defineProperty(this, 'damaged', { value: api })
    return api
  }

  get facilities() {
    const api = new Facilities(this.api)
    Object.defineProperty(this, 'facilities', { value: api })
    return api
  }

  get freight() {
    const api = new Freight(this.api)
    Object.defineProperty(this, 'freight', { value: api })
    return api
  }

  get pallets() {
    const api = new Pallets(this.api)
    Object.defineProperty(this, 'pallets', { value: api })
    return api
  }

  get parcel() {
    const api = new Parcel(this.api)
    Object.defineProperty(this, 'parcel', { value: api })
    return api
  }

  get picking() {
    const api = new Picking(this.api)
    Object.defineProperty(this, 'picking', { value: api })
    return api
  }

  get products() {
    const api = new Products(this.api)
    Object.defineProperty(this, 'products', { value: api })
    return api
  }

  get profiles() {
    const api = new Profiles(this.api)
    Object.defineProperty(this, 'profiles', { value: api })
    return api
  }

  get skus() {
    const api = new Skus(this.api)
    Object.defineProperty(this, 'skus', { value: api })
    return api
  }

  get truckloads() {
    const api = new Truckloads(this.api)
    Object.defineProperty(this, 'truckloads', { value: api })
    return api
  }

  get units() {
    const api = new Units(this.api)
    Object.defineProperty(this, 'units', { value: api })
    return api
  }

  get barcodedUnits() {
    const api = new BarcodedUnits(this.api)
    Object.defineProperty(this, 'barcodedUnits', { value: api })
    return api
  }

  get lookup() {
    const api = new Lookup(this.api)
    Object.defineProperty(this, 'lookup', { value: api })
    return api
  }
}
